import { SERVICE_DOMAIN } from '../constants.ts'

export function getHost(service: { name: string }): string {
  return `${service.name.toLowerCase()}.${SERVICE_DOMAIN}`
}

export function formatLocation(metadata?: NodeMetadata) {
  if (!metadata || !metadata.remoteAddr) return 'Unknown'

  const parts = [metadata.city, metadata.state || metadata.country].filter(Boolean)
  return parts.join(', ') || metadata.remoteAddr.toString()
}

export function getServiceLabel(service: { name: string; title?: string | null }): string {
  const host = getHost(service)
  return service.title || host
}
